import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ClerkProvider } from "@clerk/clerk-react";
import { Toaster } from "react-hot-toast";
import store, { persistor } from "./app/store";
import env from "./utils/env";
import "./index.css";

import Modal from "react-modal";
import App from "./App";

Modal.setAppElement("#root");

// MSW mocking disabled for now
async function enableMocking() {
  return
  // if (process.env.NODE_ENV !== 'development') {
  //   return
  // }

  // const { worker } = await import('./mocks/browser')
  
  // return worker.start({
  //   onUnhandledRequest: 'warn',
  // })
}

const root = ReactDOM.createRoot(document.getElementById("root")!);

const clerkPublishableKey = env("REACT_APP_CLERK_PUBLISHABLE_KEY")!;

if (!clerkPublishableKey) {
  throw new Error("Missing Publishable Key");
}

enableMocking().then(() => {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={clerkPublishableKey}>
        <BrowserRouter>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <App />
              <Toaster position="bottom-right" />
            </PersistGate>
          </Provider>
        </BrowserRouter>
      </ClerkProvider>
    </React.StrictMode>
  )
})
